import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BreadCrumbService {
   _title = signal<string>('-');
   readonly title = this._title.asReadonly();
}
